import { enter, leave } from 'el-transition'
import { Controller } from '@hotwired/stimulus'
import { FetchRequest } from '@rails/request.js'

export default class extends Controller {
  static targets = [
    'documentContainer',
    'documentContainerTrigger',
    'folderTitleSearchUrlParam',
    'openUrlParam',
  ]

  static values = {
    closeString: { type: String, default: 'Close' },
    folderId: String,
    open: { type: Boolean, default: false },
    openString: { type: String, default: 'Open' },
    reloadUrl: String,
  }

  connect() {
    this.folderTitleSearchUrlParamTargets.forEach((target) => {
      const searchParams = new URLSearchParams(target.href.split('?')[1] || '')
      const folderTitleSearch =
        document.querySelector('.js-clients-folders--folder-query')?.value || ''
      searchParams.set('folder_title_search', folderTitleSearch)
      target.href = `${target.href.split('?')[0]}?${searchParams.toString()}`
    })
  }

  handleReloadFolder({ detail: { folderId } }) {
    if (this.folderIdValue === folderId) {
      this.#reloadFolder()
    }
  }

  hideDocumentContainer() {
    this.openValue = false
  }

  openValueChanged() {
    if (this.openValue) {
      setTimeout(() => {
        enter(this.documentContainerTarget)
        this.element.classList.add('active')
        this.documentContainerTriggerTarget.textContent =
          this.documentContainerTriggerTarget.dataset.closeLabel
        this.#scrollDocumentContainerIntoView()
      }, 250)
    } else {
      leave(this.documentContainerTarget)
      this.element.classList.remove('active')
      this.documentContainerTriggerTarget.textContent =
        this.documentContainerTriggerTarget.dataset.openLabel
    }

    this.openUrlParamTargets.forEach((target) => {
      const searchParams = new URLSearchParams(target.href.split('?')[1] || '')
      searchParams.set('open', this.openValue)
      target.href = `${target.href.split('?')[0]}?${searchParams.toString()}`
    })
  }

  showDocumentContainer() {
    this.openValue = true
  }

  toggleDocumentContainer(event) {
    event.preventDefault()
    this.openValue = !this.openValue
  }

  #reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)') === true ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches === true
  }

  async #reloadFolder() {
    const request = new FetchRequest(
      'get',
      this.reloadUrlValue,
      {
        query: {
          open: this.openValue,
        },
        responseKind: 'turbo-stream',
      },
    )

    const response = await request.perform()

    if (!response.ok) {
      alert('There was an error reloading the folder. Please reload the page.')
    }
  }

  #scrollDocumentContainerIntoView() {
    if (!this.#reducedMotion()) {
      const scrollContainer = document.documentElement
      const scrollTop = this.element.getBoundingClientRect().y -
        (scrollContainer.offsetTop - scrollContainer.scrollTop)
      const offset = 80
      scrollContainer.scrollTo({
        top: scrollTop - offset,
        behavior: 'smooth',
      })
    }
  }
}
